import React from 'react';
import { Link } from 'react-router-dom';
import { ImagePlus, Settings, History, Sparkles } from "lucide-react";
import { Card } from "@/components/ui/card";
import { useAuth } from "@/contexts/AuthContext";
import { InternalPageHeader } from "@/components/ui/internal-page-header";

export default function Dashboard() {
  const { user, subscriptionTier } = useAuth();

  return (
    <div className="container mx-auto px-4 py-8">
      <InternalPageHeader 
        title="Dashboard" 
        description={`Welcome back${user?.email ? `, ${user.email.split('@')[0]}` : ''}!`} 
      />
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <Link to="/image-generation">
          <Card className="p-6 hover:shadow-lg transition-shadow">
            <div className="flex items-center gap-4">
              <div className="p-3 bg-primary/10 rounded-lg">
                <ImagePlus className="h-6 w-6 text-primary" />
              </div>
              <div>
                <h2 className="text-xl font-semibold mb-1">Generate Images</h2>
                <p className="text-muted-foreground">Create stunning AI-generated images from text descriptions</p>
              </div>
            </div>
          </Card>
        </Link>

        <Link to="/history">
          <Card className="p-6 hover:shadow-lg transition-shadow">
            <div className="flex items-center gap-4">
              <div className="p-3 bg-primary/10 rounded-lg">
                <History className="h-6 w-6 text-primary" />
              </div>
              <div>
                <h2 className="text-xl font-semibold mb-1">Generation History</h2>
                <p className="text-muted-foreground">View and manage your previously generated images</p>
              </div>
            </div>
          </Card>
        </Link>

        <Link to="/settings">
          <Card className="p-6 hover:shadow-lg transition-shadow">
            <div className="flex items-center gap-4">
              <div className="p-3 bg-primary/10 rounded-lg">
                <Settings className="h-6 w-6 text-primary" />
              </div>
              <div>
                <h2 className="text-xl font-semibold mb-1">Settings</h2>
                <p className="text-muted-foreground">Manage your account and preferences</p>
              </div>
            </div>
          </Card>
        </Link>
      </div>

      {subscriptionTier === 'free' && (
        <div className="mt-8">
          <Card className="p-6 bg-primary/5">
            <div className="flex items-center gap-4">
              <div className="p-3 bg-primary/10 rounded-lg">
                <Sparkles className="h-6 w-6 text-primary" />
              </div>
              <div>
                <h2 className="text-xl font-semibold mb-1">Upgrade Your Account</h2>
                <p className="text-muted-foreground mb-4">Get more features and credits with our premium plans</p>
                <Link to="/pricing">
                  <button className="bg-primary text-primary-foreground px-4 py-2 rounded-lg hover:bg-primary/90 transition-colors">
                    View Plans
                  </button>
                </Link>
              </div>
            </div>
          </Card>
        </div>
      )}
    </div>
  );
}
